import * as React from 'react';

function SvgIconDraftVideo(props) {
  return (
    <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M17.822 5.8L15.32 7.244V4.264c0-.692-.561-1.255-1.251-1.255H2.49c-.69 0-1.252.563-1.252 1.255v11.295c0 .692.561 1.255 1.252 1.255h11.577c.69 0 1.251-.563 1.251-1.255v-2.98l2.503 1.445a.626.626 0 00.94-.542v-7.14a.626.626 0 00-.94-.543zm-3.91 9.602H2.646V4.421h11.264v10.981zm3.441-3.275l-2.034-1.172V8.87l2.034-1.174v4.431zM4.055 6.931h2.19c.086 0 .157-.07.157-.157v-.941a.157.157 0 00-.157-.157h-2.19a.157.157 0 00-.156.157v.94c0 .087.07.158.156.158z" />
    </svg>
  );
}

export default SvgIconDraftVideo;
